module.exports = __webpack_public_path__ + "static/media/oblong_e.50b40987.svg";